module.exports = __webpack_public_path__ + "img/grid_on.d46ce7b4.svg";